import { render, staticRenderFns } from "./AccessoriesAddToCart.vue?vue&type=template&id=61a8e7b3&"
import script from "./AccessoriesAddToCart.vue?vue&type=script&lang=js&"
export * from "./AccessoriesAddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonplumb/pixelcabin/themes/lavazza-expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a8e7b3')) {
      api.createRecord('61a8e7b3', component.options)
    } else {
      api.reload('61a8e7b3', component.options)
    }
    module.hot.accept("./AccessoriesAddToCart.vue?vue&type=template&id=61a8e7b3&", function () {
      api.rerender('61a8e7b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/AccessoriesAddToCart/AccessoriesAddToCart.vue"
export default component.exports